import { render } from "./PostListComment.vue?vue&type=template&id=204e2d4b"
import script from "./PostListComment.vue?vue&type=script&lang=js"
export * from "./PostListComment.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__